import React from "react";

export const AdminDashboard: React.FC = () => {
    function redirectToGearsDashboard() {
        try {
            window.location.href = 'https://datastudio.google.com/s/tb9s_7HAqaY';
    
            return null;
        } catch (error) {
            throw error;
        }
    }

    return redirectToGearsDashboard();
}